import { applyOverrides } from '../../../shared';
import {
  commissionFields,
  commissionLayoutRow,
} from '../../../shared/cards/commissionFields';
import { commissionDetailsCard as landlordCommissionDetailsCard } from '../../landlord/cards/commissionDetailsCard';

export const commissionDetailsCard = applyOverrides(
  landlordCommissionDetailsCard,
  {
    layout: [
      commissionLayoutRow('commission'),
      commissionLayoutRow('counterpartyCommission'),
      [{ name: 'isPersonalDeal', size: 25, mobileSize: 50 }],
    ],
    fields: commissionFields('counterpartyCommission', {
      label: 'Tenant Agent’s Compensation',
      additionalLabel: 'Additional Tenant Agent’s Compensation',
      typeLabel: '',
    }),
  },
);
